module.exports = __webpack_public_path__ + "img/ic_back.78207b05.svg";